export function canSwitchMode(mode) {
    return true;
}
//# sourceMappingURL=view-mode.js.map


//////////////////
// WEBPACK FOOTER
// C:/Agent0/_work/434/s/~/ngx-bootstrap/datepicker/engine/view-mode.js
// module id = ../../../../ngx-bootstrap/datepicker/engine/view-mode.js
// module chunks = 3